import React, { useCallback, useRef } from 'react';
import classNames from 'classnames';
import EnterpriseMembersProvider from 'providers/EnterpriseMembers';
import { Enterprise, EnterpriseBusinessUnit } from 'models/Enterprises';
import TeamFilters from 'router/subrouters/Dash/subrouters/private/subrouters/Enterprise/pages/Team/components/TeamFilters';
import TeamMembersTable from 'router/subrouters/Dash/subrouters/private/subrouters/Enterprise/pages/Team/components/TeamMembersTable';
import { useLockScrollOnParamsReroute } from 'hooks/useLockScrollOnParamsReroute';
import { PAGE_PARAM_KEYWORD } from 'data/global';
import useQueryParams from 'hooks/useQueryParams';
import useEffectSkipFirst from 'hooks/useEffectSkipFirst';

import './EnterpiseTeam.styles.scss';

type EnterpiseTeamProps = {
  className?: string;
  enterprise: Partial<Enterprise>;
  refetchFlag?: boolean;
  withNavigation?: boolean;
  isRWC?: boolean;
  updateBusinessUnits: (
    updatedBusinessUnits: EnterpriseBusinessUnit[],
    shouldRefetch?: boolean,
  ) => void;
};

const EnterpiseTeam: React.FC<EnterpiseTeamProps> = (props) => {
  const {
    className,
    enterprise,
    refetchFlag,
    withNavigation = true,
    isRWC = false,
    updateBusinessUnits,
  } = props;

  const ref = useRef<HTMLDivElement>();

  const { params } = useQueryParams();

  const page = params?.[PAGE_PARAM_KEYWORD];

  const classes = classNames('enterpise-team', className);

  const scrollToStartOfTable = useCallback(
    () => ref?.current?.scrollIntoView({ block: 'start' }),
    [],
  );

  useLockScrollOnParamsReroute();

  useEffectSkipFirst(() => {
    scrollToStartOfTable();
  }, [page, scrollToStartOfTable]);

  return (
    <div className={classes} ref={ref}>
      <EnterpriseMembersProvider
        enterprise={enterprise}
        refetchFlag={refetchFlag}
        updateBusinessUnits={updateBusinessUnits}
      >
        <TeamFilters withNavigation={withNavigation} />
        <TeamMembersTable isRWC={isRWC} />
      </EnterpriseMembersProvider>
    </div>
  );
};

export default EnterpiseTeam;
